import axios from "axios";
import { toast } from "react-toastify";

// Default Axios settings
const api = axios.create({
  baseURL: "/api"
});

// Request interceptor (if needed)
api.interceptors.request.use(
  (config) => {
    // Add token if available
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Common error handling
    if (error.response) {
      if (error.response.status === 401 && !/\/(login|findPw)\.php/.test(error.config?.url || '')) {
        window.dispatchEvent(new Event('account:unauthorized'));
      }
      const errorMessage = error.response.data.message || "An error occurred.";
      toast.error(errorMessage);
    } else {
      toast.error("Network error. Please try again later.");
    }
    return Promise.reject(error);
  }
);

// Common API functions

/**
 * GET request
 * @param {string} url - The request URL
 * @param {object} params - Query parameters
 * @param {object} config - Optional Axios request configuration
 */
export const apiGet = async (url, params = {}, config = {}) => {
  try {
    const response = await api.get(url, { params, ...config });
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * POST request
 * @param {string} url - The request URL
 * @param {object} data - Request payload
 * @param {object} config - Optional Axios request configuration
 */
export const apiPost = async (url, data = {}, config = {}) => {
  try {
    const response = await api.post(url, data, config);
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * PUT request
 * @param {string} url - The request URL
 * @param {object} data - Request payload
 * @param {object} config - Optional Axios request configuration
 */
export const apiPut = async (url, data = {}, config = {}) => {
  try {
    const response = await api.put(url, data, config);
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * DELETE request
 * @param {string} url - The request URL
 * @param {object} params - Query parameters
 * @param {object} config - Optional Axios request configuration
 */
export const apiDelete = async (url, data = {}, config = {}) => {
  try {
    const response = await api.delete(url, { data, ...config });
    return response.data;
  } catch (error) {
    throw error;
  }
};
